import React from 'react';
import { useIntl } from 'react-intl';

import { HtmlEntityType } from '../../../enums/HtmlEntityType';
import { DepartmentOption } from '../../../types/Department';
import { Option } from '../../../types/Option';
import { PilotId } from '../../../types/PilotId';
import { SharedSelectProps } from '../../../types/SharedSelectProps';
import { User } from '../../../types/User';
import { Select } from '../Select';
import { transformUserOption } from './UserSelect';

interface Props<M, Role> extends SharedSelectProps<PilotId | Role, M> {
  users: User[];
  departments: DepartmentOption[];
  enableEmail?: boolean;
  enablePortal?: boolean;
  roles?: Option<Role>[];
}

export const UserDepartmentSelect = <M extends boolean, Role extends string>({
  users,
  departments,
  enableEmail = true,
  enablePortal,
  roles = [],
  value,
  onChange,
  onSearch,
  isLoading,
  ...rest
}: Props<M, Role>) => {
  const intl = useIntl();
  const userOptions = users.map(transformUserOption({ enableEmail, intl }));
  const departmentOptions = departments.map(transformToDepartmentOption);
  const options = [...roles, ...departmentOptions, ...userOptions];
  return (
    <Select
      enableErrorMessage={true}
      enablePortal={enablePortal}
      enableSelectAll={false}
      isClearable={false}
      options={options}
      value={value}
      isLoading={isLoading}
      onChange={onChange}
      onSearch={onSearch}
      {...rest}
    />
  );
};

export const transformToDepartmentOption = (department: DepartmentOption) => {
  return {
    value: `${department.id}`,
    description: `${department.path.join(` ${HtmlEntityType.RightArrow} `)} ${
      HtmlEntityType.RightArrow
    } ${department.name}`,
    label: department.name,
    leftIcon: 'department' as const,
  };
};
